var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apply_container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content_wrap"
  }, [_vm._v("\n      " + _vm._s(_vm.applyStaus) + "\n    "), (_vm.applyStaus == 107) ? _c('h3', {
    staticClass: "reson_title title_meia"
  }, [_vm._v(_vm._s('拒绝理由：' + _vm.reason))]) : _vm._e(), _vm._v(" "), (_vm.applyStaus != 103 && _vm.applyStaus != 105) ? _c('div', {
    staticClass: "form_wrap"
  }, [_c('div', {
    staticClass: "form_item"
  }, [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "required": "",
      "label": "媒体类型Media Type",
      "value": _vm.value,
      "placeholder": "请选择媒体类型"
    },
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.mediaTypeList
    },
    on: {
      "cancel": function($event) {
        _vm.showPicker = false
      },
      "confirm": _vm.onConfirm
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form_item"
  }, [(!_vm.applyStaus) ? _c('van-radio-group', {
    model: {
      value: (_vm.idCardType),
      callback: function($$v) {
        _vm.idCardType = $$v
      },
      expression: "idCardType"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "1"
    }
  }, [_vm._v("护照PASSPORT")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "2"
    }
  }, [_vm._v("港澳通行证")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form_item"
  }, [(!_vm.applyStaus) ? _c('div', {
    staticClass: "upload_wrap"
  }, [_c('span', {
    staticClass: "title_meia"
  }, [_vm._v("人脸照片Face Photo")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "after-read": _vm.afterReada
    },
    model: {
      value: (_vm.facePhoto),
      callback: function($$v) {
        _vm.facePhoto = $$v
      },
      expression: "facePhoto"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.applyStaus) ? _c('div', {
    staticClass: "upload_wrap"
  }, [_c('span', {
    staticClass: "title_meia"
  }, [_vm._v(_vm._s(_vm.idCardType == 1 ? '护照' : '港澳通行证') + "图片PASSPORT")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "after-read": _vm.afterReadb
    },
    model: {
      value: (_vm.passport),
      callback: function($$v) {
        _vm.passport = $$v
      },
      expression: "passport"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "required": "",
      "label": "姓名Name",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.formData.goodName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "goodName", $$v)
      },
      expression: "formData.goodName"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "required": "",
      "label": "护照号码 Passport No.",
      "placeholder": "请输入内容",
      "size": "large"
    },
    model: {
      value: (_vm.formData.idcardNumber),
      callback: function($$v) {
        _vm.$set(_vm.formData, "idcardNumber", $$v)
      },
      expression: "formData.idcardNumber"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "required": "",
      "label": "地区Area",
      "placeholder": "请输入内容"
    },
    on: {
      "click": function($event) {
        _vm.showCountry = true
      }
    },
    model: {
      value: (_vm.formData.region),
      callback: function($$v) {
        _vm.$set(_vm.formData, "region", $$v)
      },
      expression: "formData.region"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "required": "",
      "label": "公司网址Website",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.formData.companyUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "companyUrl", $$v)
      },
      expression: "formData.companyUrl"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "required": "",
      "label": "公司名称Company",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.formData.company),
      callback: function($$v) {
        _vm.$set(_vm.formData, "company", $$v)
      },
      expression: "formData.company"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "required": "",
      "label": "公司联系电话TEL.",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.formData.companyPhone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "companyPhone", $$v)
      },
      expression: "formData.companyPhone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "required": "",
      "label": "媒体名称Media Name",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.formData.mediaName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "mediaName", $$v)
      },
      expression: "formData.mediaName"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "required": "",
      "label": "职位TITLE",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.formData.post),
      callback: function($$v) {
        _vm.$set(_vm.formData, "post", $$v)
      },
      expression: "formData.post"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "required": "",
      "label": "个人邮箱地址Email",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload_wrap"
  }, [_c('span', {
    staticClass: "title_meia"
  }, [_vm._v("请参考“媒体注册须知”申请条件对应媒体类型上传相关资料")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "after-read": _vm.afterReadc
    },
    model: {
      value: (_vm.pressCard),
      callback: function($$v) {
        _vm.pressCard = $$v
      },
      expression: "pressCard"
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "required": "",
      "label": "手机号Mobile",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.formData.mobile),
      callback: function($$v) {
        _vm.$set(_vm.formData, "mobile", $$v)
      },
      expression: "formData.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tips_wrap"
  }, [_c('van-checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('span', [_vm._v("我已认真阅读并知悉")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showTips = true
      }
    }
  }, [_vm._v("注册须知")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form_item my_btn"
  }, [_c('van-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handelSubmit
    }
  }, [_vm._v("提交申请SUBMIT")])], 1)]) : _c('div', {
    staticClass: "qrcode_wrap"
  }, [(_vm.applyStaus == 105) ? _c('h3', {
    staticClass: "qr_name"
  }, [_vm._v(_vm._s(_vm.applyDetail.goodName))]) : _vm._e(), _vm._v(" "), (_vm.applyStaus == 103) ? _c('div', {
    staticClass: "box_show"
  }, [_c('span', [_vm._v("您的资料已提交，请耐心等待审核，审核通过后，我们将通过邮件通知您。")])]) : _vm._e(), _vm._v(" "), (_vm.applyStaus == 105) ? _c('div', {
    staticClass: "box_show"
  }, [_c('img', {
    attrs: {
      "src": _vm.qrcodeUrl,
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showCountry),
      callback: function($$v) {
        _vm.showCountry = $$v
      },
      expression: "showCountry"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.countryData
    },
    on: {
      "cancel": function($event) {
        _vm.showCountry = false
      },
      "confirm": _vm.onConfirmCountry
    }
  })], 1), _vm._v(" "), _c('van-text-dialog', {
    attrs: {
      "show": _vm.showTips,
      "title": "2023年第二十一届广州国际汽车展览会",
      "body": _vm.content,
      "mask": "",
      "button-text": "我已知悉"
    },
    on: {
      "confirm": _vm.comfirm,
      "close": _vm.close,
      "toggle": _vm.toggle
    }
  })], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header_img"
  }, [_c('img', {
    attrs: {
      "src": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/a2478bade007269fc0c7236a423bd5b9.jpg"
    }
  })])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19d2db8b","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mediaCenter/foreignMedia.vue
// module id = null
// module chunks = 